import { useState, useEffect, useMemo } from "react";
import { getAllIds } from "~/helpers/ArrayHelpers";

export function useActiveSectionId(ids = [], offset = 100, blogId = "") {
    const allIds = useMemo(() => {
        let processedIds = getAllIds(ids);

        if (blogId && !processedIds.includes(blogId)) {
            processedIds = [blogId, ...processedIds];
        }

        return processedIds;
    }, [ids, blogId]);

    const [activeId, setActiveId] = useState(allIds[0] || "");

    useEffect(() => {
        if (!allIds.length) return;
        function handleScroll() {
            let current = allIds[0]; // Default to first (usually blogId)
            for (const id of allIds) {
                const el = document.getElementById(id);
                if (el && el.getBoundingClientRect().top - offset <= 0) {
                    current = id;
                }
            }
            setActiveId(current);
        }

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
    }, [allIds, offset]);

    return activeId;
}